export default __webpack_public_path__ + "static/media/days.e0cb3796.png";